import React, { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FaArrowRight, FaSearch } from "react-icons/fa";
import SEO from "../components/SEO";
import { findSiteMatches } from "../data/siteCatalog";
import "../style/SearchPage.css";

const quickLinks = [
  { label: "Zombie Crushers", to: "/games/zombie-crushers" },
  { label: "WarFront", to: "/games/warfront" },
  { label: "Ghost Hunter", to: "/games/ghost-hunter" },
  { label: "Store", to: "/store" },
  { label: "Piattaforma", to: "/services" },
  { label: "Supporto", to: "/contact" },
  { label: "Privacy", to: "/privacy" }
];

export default function SearchPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const results = useMemo(() => findSiteMatches(query, 12), [query]);

  const handleSubmit = event => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const nextQuery = String(formData.get("q") || "").trim();
    setSearchParams(nextQuery ? { q: nextQuery } : {});
  };

  return (
    <section className="search-page">
      <SEO
        title={query ? `Ricerca "${query}" | Kyros Games` : "Ricerca | Kyros Games"}
        description="Cerca giochi Kyros, piattaforma, Store, launcher, privacy, supporto e contatti."
        canonical="https://kyrosgames.com/search"
      />

      <header className="search-page__header">
        <span className="search-page__eyebrow">Ricerca</span>
        <h1>Cerca nel sito Kyros</h1>
        <form className="search-page__form" role="search" onSubmit={handleSubmit}>
          <label htmlFor="site-search">Termine cercato</label>
          <div>
            <input
              id="site-search"
              name="q"
              type="search"
              defaultValue={query}
              placeholder="Zombie Crushers, WarFront, piattaforma, privacy..."
            />
            <button type="submit">
              <FaSearch aria-hidden="true" />
              <span>Cerca</span>
            </button>
          </div>
        </form>
      </header>

      <div className="search-page__body">
        {query ? (
          <p className="search-page__count">
            {results.length
              ? `${results.length} risultati per "${query}"`
              : `Nessun risultato per "${query}"`}
          </p>
        ) : (
          <p className="search-page__count">Inserisci un termine di ricerca o usa un collegamento rapido.</p>
        )}

        {results.length > 0 ? (
          <div className="search-page__results">
            {results.map(result => (
              <Link key={result.id} to={result.to} className="search-result">
                <span className="search-result__type">{result.type}</span>
                <strong>{result.title}</strong>
                <p>{result.description}</p>
                <span className="search-result__cta">
                  Apri
                  <FaArrowRight aria-hidden="true" />
                </span>
              </Link>
            ))}
          </div>
        ) : (
          <section className="search-page__empty">
            <h2>Prova una ricerca più concreta</h2>
            <p>
              Le ricerche più utili sono giochi, piattaforma, launcher, Store, privacy e supporto.
              La ricerca non rimanda alla Home quando non trova risultati.
            </p>
            <div className="search-page__quick-links">
              {quickLinks.map(link => (
                <Link key={link.to} to={link.to}>
                  {link.label}
                </Link>
              ))}
            </div>
          </section>
        )}
      </div>
    </section>
  );
}
